import {
  buildAshpConcentration,
  buildFormulationRows,
  buildFormulationSummary,
  buildRtuFormulations,
  buildUsageTrendRows,
} from './__fixtures__/investigationFixtures';
// Uncomment along with the requests below.
// import { GET_METHOD, Request } from '@/lib/http';

// Investigate's server data. TEMPORARY: none of these endpoints exist yet, so
// each method resolves fixture rows in the endpoint's documented shape. The real
// call sits commented above each one — swapping is per-method: uncomment the
// request plus the imports, delete the fixture return. See
// INVESTIGATE_DATA_CONTRACTS.md.
//
// Separate from services/analysis.js, which declares two of the same endpoints
// against `/api/analysis` and is shared with the not-yet-ported Analyze page —
// pointing Investigate there would couple this page's rollout to Analyze's.

// const baseURL = '/api/formulary';

export default {
  // -> { formulations: [{ formulation, infusions, wasteWeightedPct,
  //                       concentrationValue, concentrationUnit,
  //                       volumeValue, volumeUnit, minRate, maxRate }],
  //      summary: { totalInfusions, averageWastePct, minFlowRate, maxFlowRate } }
  //
  // Rows arrive READY TO RENDER: already past the min-infusions floor, already
  // without the `infusions <= 0` rows, and already sorted by infusions
  // descending. The client neither filters nor sorts them.
  //
  // `summary` is the table's footer row. Those four figures are aggregates over
  // the whole filtered set, so they come from the same scan that produced the
  // rows rather than being re-derived in the browser — which is the only way
  // they stay correct once the row list is ever paged or truncated, and the
  // only way the infusion-weighted waste ratio is computed from full precision
  // instead of from rounded per-row percentages.
  getFormulations(scope) {
    // const queryString = generateQueryParamsString({
    //   medication: scope.medicationName,
    //   start: scope.startDate || '',
    //   end: scope.endDate || '',
    //   facilities: scope.facilities || [],
    //   patientPopulations: scope.patientPopulations || [],
    //   // Omitted entirely when absent, so the server can tell "no threshold"
    //   // from "a threshold of 0".
    //   ...(scope.minInfusions != null ? { minInfusions: scope.minInfusions } : {}),
    //   includeFlowRates: true,
    // });
    // const request = new Request(`${baseURL}/formulations${queryString}`, { method: GET_METHOD });
    // return request.send();
    const formulations = buildFormulationRows(scope);
    return Promise.resolve({ formulations, summary: buildFormulationSummary(formulations) });
  },

  // -> { trends: [{ year, month, formulation, infusions }] }
  //
  // The 6-full-month window is computed by the caller (utils/trendWindow)
  // and passed as ordinary dates; the server needs no notion of "full months".
  // Months with no data for a formulation may be absent rather than zero-filled.
  //
  // `minInfusions` is applied over the WHOLE WINDOW, not per month — the same
  // "in use" floor #2 applies, so the chart's series and the table's rows are
  // the same set of formulations. Per-month would gap a series whose window
  // total clears the floor easily, and would disagree with the table.
  getUsageTrends(scope) {
    // const queryString = generateQueryParamsString({
    //   medication: scope.medicationName,
    //   start: scope.startDate || '',
    //   end: scope.endDate || '',
    //   facilities: scope.facilities || [],
    //   patientPopulations: scope.patientPopulations || [],
    //   minInfusions: scope.minInfusions ?? 5,
    // });
    // const request = new Request(`${baseURL}/investigation/usage-trends${queryString}`, {
    //   method: GET_METHOD,
    // });
    // return request.send();
    return Promise.resolve({ trends: buildUsageTrendRows(scope) });
  },

  // -> { medicationName, concentrations: [{ concentration, unit, cohort }],
  //      dosingUnits, references } or null where ASHP hasn't standardized the
  // drug, which the alignment badges render as N/A.
  //
  // Not scope-dependent: the standards are a property of the drug.
  getAshpConcentration(medicationName) {
    // const request = new Request(
    //   `${baseURL}/medications/${encodeURIComponent(medicationName)}/ashp-concentration`,
    //   { method: GET_METHOD }
    // );
    // return request.send();
    return Promise.resolve(buildAshpConcentration(medicationName));
  },

  // -> { rtuFormulations: [{ formulation, concentrationValue, concentrationUnit,
  //                          volumeValue, volumeUnit, category, manufacturer, ndc }] }
  getRtuFormulations(medicationName) {
    // const request = new Request(
    //   `${baseURL}/medications/${encodeURIComponent(medicationName)}/rtu-formulations`,
    //   { method: GET_METHOD }
    // );
    // return request.send();
    return Promise.resolve({ rtuFormulations: buildRtuFormulations(medicationName) });
  },
};
